module.exports = __webpack_public_path__ + "img/pole-status-red.34537774.png";